import VueCookie from 'vue-cookie';

export default {
  install: (app) => {
    app.config.globalProperties.$cookie = VueCookie;
  }
};